module.exports = __webpack_public_path__ + "static/media/drawer.a69bae66.svg";